export default "__VITE_ASSET__c9fb706e__"